import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#67BD38"
        fillRule="evenodd"
        d="M11 0h5v12h-5V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E47E00"
        fillRule="evenodd"
        d="M0 0h5v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M5 0h6v12H5V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
